import React from 'react';
import _ from 'lodash';
import { Box, FormControl, FormHelperText, InputLabel, Select, MenuItem, Checkbox, ListItemText, Typography } from '@mui/material';

import { RequiredField } from '../others/RequiredField';
import { InfoField } from './InfoField';

export const MultiChoiceField = props => {
  const { field, formik, getFieldCallback } = props;

  const handleChange = e => {
    formik.setFieldValue(field.name, e.target.value);
  };

  return (
    <Box>
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={_.isEmpty(formik.values[field.name])} />
      </Typography>
      <FormControl
        style={{ marginBottom: 15 }}
        fullWidth
        variant="standard"
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}>
        <InputLabel id={field.name}>{_.isEmpty(formik.values[field.name]) ? field.label : null}</InputLabel>
        <Select
          labelId={field.name}
          multiple
          value={formik.values[field.name] || []}
          onChange={e => handleChange(e)}
          renderValue={selected => selected.join(', ')}
        >
          { !_.isNil(formik.values[field.name])
            ? _.map(field.options, (name, key) => (
              <MenuItem key={key} value={name}>
                <Checkbox checked={formik.values[field.name].indexOf(name) > -1 || false} />
                <ListItemText primary={name} />
              </MenuItem>
            ))
            : null}
        </Select>
        <FormHelperText>{formik.touched[field.name] && formik.errors[field.name]}</FormHelperText>
        {
          !_.isEmpty(field.infos)
            ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
            : null
        }
      </FormControl>
    </Box>
  );
};
